export default __webpack_public_path__ + "static/media/pursuit-menu-allresults-on.83089629.svg";